import axios from "@/axios.js";
import lk from "../../http/requests/lookup/index.js";
import photoUpload from "../../http/requests/photo/index.js";
export default {
  getAllShiftType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/lookup/shifttype/getAllShiftType")
        .then((response) => {
          commit("GET_ALL_SHIFTTYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  addShiftType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/shifttype/create", items)
        .then((response) => {
          commit("ADD_ShiftType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateShiftType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/shifttype/update", items)
        .then((response) => {
          commit("UPDATE_ShiftType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllScheduleType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/lookup/scheduletype/getAllScheduleType")
        .then((response) => {
          commit("GET_ALL_SCHEDULETYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  addScheduleType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/scheduletype/create", items)
        .then((response) => {
          commit("ADD_SCHEDULETYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateScheduleType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/scheduletype/update", items)
        .then((response) => {
          commit("UPDATE_ScheduleType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllSegmentType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/lookup/segmenttype/getAllSegmentType")
        .then((response) => {
          commit("GET_ALL_SEGMENTTYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  addSegmentType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/segmenttype/create", items)
        .then((response) => {
          commit("ADD_SEGMENTTYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSegmentType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/segmenttype/update", items)
        .then((response) => {
          commit("UPDATE_SegmentType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLeaveTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLeaveTypeLookup()
        .then((response) => {
          commit("GET_ALL_LEAVETYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addLeaveTypeLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/leavetype/create", items)
        .then((response) => {
          commit("ADD_LEAVETYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateLeaveTypeLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/leavetype/update", items)
        .then((response) => {
          commit("UPDATE_LeaveType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllClaimsCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllClaimCategory()
        .then((response) => {
          commit("GET_ALL_CLAIMCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addClaimCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/claimsCategory/create", items)
        .then((response) => {
          commit("ADD_CLAIMCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateClaimsCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/claimsCategory/update", items)
        .then((response) => {
          commit("UPDATE_ClaimsCategory", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllClaimsSubCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllClaimSubCategory()
        .then((response) => {
          commit("GET_ALL_CLAIMSUBCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addClaimsSubCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/claimsSubCategory/create", items)
        .then((response) => {
          commit("ADD_CLAIMSUBCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateClaimsSubCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/claimsSubCategory/update", items)
        .then((response) => {
          commit("UPDATE_ClaimsSubCategory", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllLoanType({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/lookup/LoanType/getAllLoanType")
        .then((response) => {
          commit("GET_ALL_LOANTYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addLoanType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/loanType/create", items)
        .then((response) => {
          commit("ADD_LOANTYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateLoanType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/loanType/update", items)
        .then((response) => {
          commit("UPDATE_LOANTYPE", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLoanName({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/lookup/LoanName/getAllLoanName")
        .then((response) => {
          commit("GET_ALL_LOANNAME", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addLoanName({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/loanName/create", items)
        .then((response) => {
          commit("ADD_LOANNAME", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateLoanName({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/loanName/update", items)
        .then((response) => {
          commit("UPDATE_LOANNAME", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLoanCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLoanCategory()
        .then((response) => {
          commit("GET_ALL_LOANCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addLoanCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/LoanCategory/create", items)
        .then((response) => {
          commit("ADD_LoanCategory", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateLoanCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/loanCategory/update", items)
        .then((response) => {
          commit("UPDATE_loanCategory", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLoanSubCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLoanSubCategory()
        .then((response) => {
          commit("GET_ALL_LOANSUBCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addLoanSubCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/LoanSubCategory/create", items)
        .then((response) => {
          commit("ADD_LoanSubCategory", response.data.data); //Object.assign(items, {deductionsTypeId: response.data.data.deductionsTypeId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateLoanSubCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/LoanSubCategory/update", items)
        .then((response) => {
          commit("UPDATE_LoanSubCategory", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteLoanSubCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/lookup/LoanSubCategory/${id}`)
        .then((response) => {
          commit("DELETE_LoanSubCategory", id); //Object.assign(item, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllOvertimeType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllOvetimeType()
        .then((response) => {
          commit("GET_ALL_OVERTIMETYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addOvertimeType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/overtimetype/create", items)
        .then((response) => {
          commit("ADD_OvertimeType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateOvertimeType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/overtimetype/update", items)
        .then((response) => {
          commit("UPDATE_OvertimeType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDepartment({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDepartment()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Department", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addDepartment({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/department/create", items)
        .then((response) => {
          commit("ADD_Department", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDepartment({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/department/update", items)
        .then((response) => {
          commit("UPDATE_Department", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllCreatePayrollTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllCreatePayrollTypeLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_CreatePayrollType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addCreatePayrollType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/createPayrollType/create", items)
        .then((response) => {
          commit("ADD_CreatePayrollType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateCreatePayrollType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/createPayrollType/update", items)
        .then((response) => {
          commit("UPDATE_CreatePayrollType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllBranch({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllBranch()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Branch", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addBranch({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/branch/create", items)
        .then((response) => {
          commit("ADD_BRANCH", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateBranch({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/branch/update", items)
        .then((response) => {
          commit("UPDATE_BRANCH", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllPosition({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllPosition()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Position", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addPosition({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/position/create", items)
        .then((response) => {
          commit("ADD_POSITION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePosition({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/position/update", items)
        .then((response) => {
          commit("UPDATE_POSITION", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDivision({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDivision()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Division", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addDivision({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/division/create", items)
        .then((response) => {
          commit("ADD_DIVISION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDivision({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/division/update", items)
        .then((response) => {
          commit("UPDATE_DIVISION", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllSection({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllSection()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Section", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addSection({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/section/create", items)
        .then((response) => {
          commit("ADD_SECTION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSection({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/section/update", items)
        .then((response) => {
          commit("UPDATE_SECTION", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllEmployeeCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllEmployeeCategory()
        .then((response) => {
          //console.log('CATEGORY EMPLOYEE')
          //console.log(response.data.data);
          commit("GET_ALL_EmployeeCategory", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addEmployeeCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/employeeCategory/create", items)
        .then((response) => {
          commit("ADD_EMPLOYEECATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateEmployeeCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/employeeCategory/update", items)
        .then((response) => {
          commit("UPDATE_EMPLOYEECATEGORY", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllEarningsType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllEarningsType()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_EarningsType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addEarningsType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/EarningsType/create", items)
        .then((response) => {
          commit("ADD_EarningsType", response.data.data); //Object.assign(items, {earningsTypeId: response.data.data.earningsTypeId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateEarningsType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/EarningsType/update", items)
        .then((response) => {
          commit("UPDATE_EarningsType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteEarningsType({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/lookup/EarningsType/${id}`)
        .then((response) => {
          commit("DELETE_EarningsType", response.data.data); //Object.assign(item, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllEarningsCategory({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/lookup/EarningsCategory/getAllEarningsCategory")
        .then((response) => {
          commit(
            "GET_ALL_EarningsCategory",
            JSON.parse(JSON.stringify(response.data.data))
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addEarningsCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/earningsCategory/create", items)
        .then((response) => {
          commit("ADD_EARNINGSCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateEarningsCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/earningsCategory/update", items)
        .then((response) => {
          commit("UPDATE_EARNINGSCATEGORY", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDeductionsType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDeductionsType()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_DeductionsType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addDeductionsType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/DeductionsType/create", items)
        .then((response) => {
          commit("ADD_DeductionsType", response.data.data); //Object.assign(items, {deductionsTypeId: response.data.data.deductionsTypeId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDeductionsType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/DeductionsType/update", items)
        .then((response) => {
          commit("UPDATE_DeductionsType", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteDeductionsType({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/lookup/DeductionsType/${id}`)
        .then((response) => {
          commit("DELETE_DeductionsType", id); //Object.assign(item, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDeductionsCategory({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/lookup/DeductionsCategory/getAllDeductionsCategory")
        .then((response) => {
          commit(
            "GET_ALL_DeductionsCategory",
            JSON.parse(JSON.stringify(response.data.data))
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addDeductionsCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/deductionsCategory/create", items)
        .then((response) => {
          commit("ADD_DEDUCTIONSCATEGORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDeductionsCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/deductionsCategory/update", items)
        .then((response) => {
          commit("UPDATE_DEDUCTIONSCATEGORY", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllCivilStatus({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllCivilStatus()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_CivilStatus", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addCivilStatus({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/civilStatus/create", items)
        .then((response) => {
          commit("ADD_CIVILSTATUS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateCivilStatus({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/civilStatus/update", items)
        .then((response) => {
          commit("UPDATE_CIVILSTATUS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllNationality({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllNationality()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Nationality", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addNationality({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/nationality/create", items)
        .then((response) => {
          commit("ADD_NATIONALITY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateNationality({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/nationality/update", items)
        .then((response) => {
          commit("UPDATE_NATIONALITY", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllReligion({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllReligion()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Religion", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addReligion({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/religion/create", items)
        .then((response) => {
          commit("ADD_RELIGION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateReligion({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/religion/update", items)
        .then((response) => {
          commit("UPDATE_RELIGION", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllRelationshipLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllRelationshipLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Relationship", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addRelationshipLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/relationship/create", items)
        .then((response) => {
          commit("ADD_RELATIONSHIPLOOKUP", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateRelationshipLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/relationship/update", items)
        .then((response) => {
          commit("UPDATE_RELATIONSHIPLOOKUP", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAccreditationType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAccreditationType()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_AccreditationType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addAccreditationType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/accreditationType/create", items)
        .then((response) => {
          commit("ADD_ACCREDITATIONTYPE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAccreditationType({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/accreditationType/update", items)
        .then((response) => {
          commit("UPDATE_ACCREDITATIONTYPE", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllRankLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllRankLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Rank", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addRankLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/rank/create", items)
        .then((response) => {
          commit("ADD_RANK", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateRankLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/rank/update", items)
        .then((response) => {
          commit("UPDATE_RANK", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAssociationLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAssociationLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Association", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addAssociationLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/association/create", items)
        .then((response) => {
          commit("ADD_ASSOCIATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAssociationLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/association/update", items)
        .then((response) => {
          commit("UPDATE_ASSOCIATION", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllBankLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllBankLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Bank", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addBankLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/bank/create", items)
        .then((response) => {
          commit("ADD_BANK", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateBankLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/bank/update", items)
        .then((response) => {
          commit("UPDATE_BANK", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllPeriodLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllPeriodLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Period", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllBenefitTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllBenefitTypeLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_BenefitType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLineOfBusinessLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLineOfBusinessLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_LineOfBusiness", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDegreeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDegreeLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Degree", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAreaOfStudyLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAreaOfStudyLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_AreaOfStudy", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllInstitutionLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllInstitutionLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Institution", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAwardLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAwardLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Award", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAppraisalTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAppraisalTypeLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_AppraisalType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addAppraisalTypeLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/appraisaltype/create", items)
        .then((response) => {
          commit("ADD_AppraisalType", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAppraisalTypeLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/appraisaltype/update", items)
        .then((response) => {
          commit("UPDATE_AppraisalTypeLookup", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllMarketSegmentLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllMarketSegmentLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_MarketSegment", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAppraisalRatingLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAppraisalRatingLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_AppraisalRating", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addAppraisalRatingLookup({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/lookup/appraisalrating/create", items)
        .then((response) => {
          commit("ADD_AppraisalRating", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAppraisalRating({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/appraisalrating/update", items)
        .then((response) => {
          commit("UPDATE_AppraisalRating", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllSalaryBasedOnLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllSalaryBasedOnLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_SalaryBasedOn", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllScheduleNumber({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllScheduleNumber()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_ScheduleNumber", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllTaxReferenceLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllTaxReferenceLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_TaxReference", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllPaymentModeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllPaymentModeLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_PaymentMode", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePayment({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/lookup/paymentMode/update", items)
        .then((response) => {
          commit("UPDATE_PAYMENT", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllViolationLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllViolationLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_Violation", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllViolationActionLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllViolationActionLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_ViolationAction", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllMedicalProcedureLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllMedicalProcedureLookup()
        .then((response) => {
          //console.log(response.data.data);
          commit("GET_ALL_MedicalProcedure", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllCountryLookup({ commit }, source) {
    return new Promise((resolve, reject) => {
      lk.getAllCountryLookup(source)
        .then((response) => {
          let country = [];
          for (var c = 0; c < response.data.length; c++) {
            if (response.data[c].countryCode != this.countryCode) {
              this.countryCode = response.data[c].countryCode;
              country.push(response.data[c]);
            }
          }
          commit("GET_ALL_Country", country);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
